import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Slider from "rc-slider";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";

const Handle = Slider.Handle;

class DropdownSliderPrice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            caption: this.props.caption,
            disabled: this.props.disabled,
            error: this.props.error,
            currency: this.props.currency,
            value: this.props.value
        };
    };

    componentWillMount() {
    };

    componentDidMount() {
        this.setState({
            currency: this.props.currency,
            value: this.props.value
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            caption: nextProps.caption,
            disabled: nextProps.disabled,
            error: nextProps.error,
            currency: nextProps.currency,
            value: nextProps.value
        });
    }

    functions = {
        increase: () => {
            if(!this.state.disabled){
                this.state.value++;
                this.props.onChange(this.state.value);
            }
        },
        decrease: () => {
            if(!this.state.disabled){
                let value = JSON.parse(JSON.stringify(this.state.value));
                value--;
                if (value === 0 || value > 0) {
                    this.state.value--;
                    this.props.onChange(this.state.value);
                }
            }
        },
        set: (value) => {
            this.props.onChange(value);
        }
    };

    renders = {
        value: (value) => {
            try {
                return JSON.parse(value).title;
            } catch (e) {
            }
        },
        handle: (props) => {
            const {value, ...restProps} = props;
            return (<Handle value={value} {...restProps} />);
        },
        number: (number) => {
            try {
                number = Math.round(number * 100) / 100;
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        text: (item) => {
            return langRegister.get("dropdown-slider-price", item);
        },
    };

    toggleEditing() {
        this.setState({isEditing: !this.state.isEditing});
    }

    render() {
        return (
            <div className={Styles.slidersContainer}>
                <div className={Styles.sliderInner}>
                    {
                        <div className={Styles.sliderInnerContainer}>
                            <div style={this.state.disabled?{backgroundColor: "#888882"}:{backgroundColor: "#00273A"}} onClick={() => this.functions.decrease()} className={Styles.sliderInnerContainerCircle}>
                                <img className={Styles.sliderInnerContainerCircleMinus}
                                     src={require("../../assets/images/minus_icon_white_small.png")}/>
                            </div>
                            <div className={Styles.sliderInnerContainerInner}>
                                <Slider
                                    handleStyle={this.state.disabled?{backgroundColor: "#888882"}:{backgroundColor: "#00273A"}}
                                    trackStyle={this.state.disabled?{backgroundColor: "#888882"}:{backgroundColor: "#00273A"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    disabled={this.state.disabled}
                                    max={this.props.max ? this.props.max : 100000000}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.value}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            </div>
                            <div style={this.state.disabled?{backgroundColor: "#888882"}:{backgroundColor: "#00273A"}} onClick={() => this.functions.increase()} className={cx(Styles.sliderInnerContainerCircle, Styles.sliderInnerContainerCircleRight)}>
                                <img className={Styles.sliderInnerContainerCirclePlus} src={require("../../assets/images/plus_sign_white_small.png")}/>
                            </div>
                            <div className={Styles.sliderInnerContainerInnerRail}/>
                            <div style={this.state.disabled?{backgroundColor: "#888882"}:{backgroundColor: "#00273A"}} className={Styles.sliderInnerContainerInnerRailLeft}/>
                        </div>
                    }
                    <div className={Styles.sliderInnerBoxes}>
                        {/*cx(Styles.sliderValue,Styles.sliderValueLong)*/}
                        <div className={
                            cx(Styles.sliderNewLong,
                                {
                                    [Styles.inputSliderYieldlock]: true,
                                    [Styles.dropdownErrorYieldlock]: (this.state.error && this.state.value < 1)
                                })
                        }>
                            {
                                <input disabled={this.state.disabled}
                                       type={this.state.isEditing?"number":"text"}
                                       onChange={(event) => {
                                           this.setState({
                                               value: event.target.value
                                           }, () => {
                                               try {
                                                   this.props.onChange(this.state.value);
                                               } catch (e) {}
                                           });
                                       }}
                                       onFocus={this.toggleEditing.bind(this)}
                                       onBlur={this.toggleEditing.bind(this)}
                                       value={this.state.isEditing?this.state.value:this.renders.number(this.state.value)}
                                       className={
                                           cx(Styles.inputSlider, Styles.sliderValueLong,
                                               {
                                                   [Styles.addressContainerInputErrorYieldlock]: (true && this.state.error && this.state.value < 1),
                                                   [Styles.addressContainerInputDisabled]: this.state.disabled,
                                               })
                                       }
                                />
                            }
                            {
                                false &&
                                <input disabled={this.state.disabled} type={"number"} onChange={(event) => {
                                    this.setState({
                                        value: event.target.value
                                    }, () => {
                                        try {
                                            this.props.onChange(this.state.value);
                                        } catch (e) {
                                        }
                                    });
                                }} value={this.state.value} className={Styles.inputSlider}/>
                            }
                        </div>
                        <div className={cx(Styles.sliderValueDivider)}>
                            &#183;
                        </div>
                        <div className={cx(Styles.sliderValue, Styles.sliderValueLong)}>
                            <div style={this.state.disabled?{color: "#888882"}:{color: "#00273A"}}
                                 className={Styles.sliderValueText}>
                                {this.state.currency}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DropdownSliderPrice;


// WEBPACK FOOTER //
// ./src/components/dropdown-slider-price/component.js